export const toContacts = contacts =>
  contacts.map(contact => ({
    value: contact.id,
    label: contact.firstName + ' ' + contact.lastName
  }))
